import { MdCheckCircle } from 'react-icons/md';
import { hospiumProducts } from '../HospiumContent';
import logoWorded from '../assets/logo_worded.png';
import InquiryCta from '../ones/InquiryCta';
import Footer from '../ones/Footer';

export default function ServicesLanding() {
  return (
    <>
      <header className="HospiumPageHero">
        <div className="container"><span className="HospiumKicker">Products and services</span><h1>Digital healthcare tools that fit the way you work</h1><p>Start with the product your organization needs today and grow into a connected Hospium ecosystem.</p></div>
      </header>
      <main className="HospiumProductsPage">
        <div className="container">
          {hospiumProducts.map((product, index) => (
            <article className={`HospiumProductDetail ${index % 2 ? 'is-reversed' : ''}`} key={product.key}>
              <div className="HospiumProductDetailImage" style={{ backgroundImage: `url(${product.image})` }}><img src={logoWorded} alt="Hospium" /></div>
              <div className="HospiumProductDetailCopy">
                <span className="HospiumKicker">{product.label}</span><h2>{product.name}</h2><p>{product.description}</p>
                <div className="HospiumDetailPoints">{product.points.map((point) => <span key={point}><MdCheckCircle /> {point}</span>)}</div>
              </div>
            </article>
          ))}
        </div>
      </main>
      <InquiryCta compact />
      <Footer />
    </>
  );
}
